import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route changes (pushState OR pop
 * via browser back/forward). Mount once inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    // Anchor links (#section) — let the browser handle scrolling to the anchor
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search, hash]);
  return null;
}
